var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-skeleton-loader',{attrs:{"type":"list-item@2","loading":_vm.loading}},[_c('div',[_c('px-carrinho-opcoes-frete',{attrs:{"agrupamento":_vm.agrupamento,"configuracao-frete":_vm.configuracaoFrete},on:{"change":_vm.onChangeFrete}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }